import { WebApi } from '@/services/WebApi'

const state = () => ({
  fetchedGeneralRegistrationSettings: false,
  fetchingGeneralRegistrationSettings: false,
  generalRegistrationSettings: null,
  attemptedGeneralRegistrationSettings: false
})

const mutations = {
  setFetching (state, fetching) {
    state.fetchingGeneralRegistrationSettings = !!fetching
    state.fetchedGeneralRegistrationSettings = false
    state.attemptedGeneralRegistrationSettings = true
  },
  setGeneralRegistrationSettings (state, generalRegistrationSettings) {
    state.generalRegistrationSettings = generalRegistrationSettings
    state.fetchingGeneralRegistrationSettings = false
    state.fetchedGeneralRegistrationSettings = true
  }
}

const actions = {
  fetchGeneralRegistrationSettings ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('setFetching', true)
      WebApi.get('GeneralRegistration/Setting')
        .then(response => {
          commit('setGeneralRegistrationSettings', response.data)
          resolve(response)
        })
        .catch(error => {
          commit('setFetching', false)
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
